import { useState, useEffect, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import CustomPagination from "../utils/paginationUtils";
import SearchIcon from "../assets/searchIcon.svg";
import {
  getInactiveHospitals,
  approveHospital,
  updatehospital,
} from "../services/HospitalServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import CrossIcon from "../assets/crossIcon.svg";
import { CircularProgress } from "@mui/material";
import HospitalList from "./HospitalList";

const ApproveHospital = () => {
  const [submitting, setSubmitting] = useState(false);
  const [hospitals, setHospitals] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  // const [sortBy, setSortBy] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1); // ✅ ADDED THIS
  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [count, setCount] = useState(0);
  const [selectedHospitalId, setSelectedHospitalId] = useState(null);
  const searchTimeRef = useRef();
  const limit = 10;

  const handleSearch = (e) => {
    if (searchTimeRef.current) clearInterval(searchTimeRef.current);
    searchTimeRef.current = setTimeout(() => setSearchKey(e.target.value), 500);
    setPage(1);
  };

  const getList = async () => {
    try {
      const result = await getInactiveHospitals(searchKey, page, limit);
      setHospitals(result.data.hospitals || []);
      setTotalPages(result.data.totalPages || 1);
      setCount(result.data.total);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handlePreApproveAdmission = async (hospital) => {
    const data = {
      preAdmissionApproval:
        hospital?.preAdmissionApproval === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };
    try {
      await updatehospital(hospital?.id, data);
      await getList();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleHospitalApprove = async (hospitalId, status) => {
    setSubmitting(true);
    try {
      await approveHospital(hospitalId, status);
      setApproveModal(false);
      setRejectModal(false);
      alert(
        `Hospital ${status === "ACTIVE" ? "approved" : "rejected"} successfully`
      );
      await getList();
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setSubmitting(false);
  };

  useEffect(() => {
    getList();
  }, [page, searchKey, count]);

  return (
    <div
      style={{ fontFamily: "Inter", padding: 32, marginTop: 93, width: "100%" }}
    >
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp;/
        &nbsp;Dashboard &nbsp;/ &nbsp;Approve Hospital
      </span>
      <div className="heading">Approve Hospital ({count})</div>

      <div style={{ border: "1px solid #E7E7E7", margin: "24px 0" }} />

      <div
        style={{ border: "1px solid #E4E4E4" }}
        className="p-6 rounded-[16px]"
      >
        {/* Search & Sort */}
        <div className="flex justify-between items-center flex-wrap gap-3">
          <div className="text-xl font-semibold">Manage Approval</div>

          <div className="flex items-center gap-2 rounded-[8px] border border-[#E4E4E4] px-4 py-[6px]">
            <img
              src={SearchIcon}
              alt="Search Icon"
              className="w-4 h-4 opacity-60"
            />{" "}
            <input
              type="text"
              placeholder="Search anything"
              className="px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#017C57] focus:border-[#017C57] transition-all duration-200 w-full"
              onChange={handleSearch}
            />
          </div>

          {/* <div className="flex items-center gap-4">
            <div className="text-sm text-[#797979]">Sort by</div>
            <select
              name="documentStatus"
              id="documentStatus"
              style={{ border: "1px solid #017C57" }}
              className="rounded-full text-[#017C57] bg-white py-2 px-4 cursor-pointer"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="">Document Status</option>
              <option value="ready_for_approval">Ready For Approval</option>
              <option value="rejected">Rejected</option>
              <option value="pending">Pending</option>
            </select>
          </div> */}
        </div>

        {/* Hospital List Component */}
        <HospitalList
          hospitals={hospitals}
          handlePreApproveAdmission={handlePreApproveAdmission}
          setSelectedHospitalId={setSelectedHospitalId}
          setApproveModal={setApproveModal}
          setRejectModal={setRejectModal}
        />

        {/* Pagination - ✅ FIXED: Added totalPages */}
        <div className="flex justify-center mt-8 my-8">
          <CustomPagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        </div>
      </div>

      {/* Approve Modal */}
      {approveModal && (
        <div className="fixed top-0 left-0 h-screen w-screen flex justify-center items-center bg-[#017c5780] z-30">
          <div className="relative h-[340px] w-[720px] flex justify-center items-center bg-white rounded-[16px]">
            <div className="w-full">
              <div className="text-2xl font-semibold text-[#191919] text-center">
                Are you sure you want to approve?
              </div>
              {submitting ? (
                <div className="flex justify-center mt-14">
                  <CircularProgress />
                </div>
              ) : (
                <div className="flex justify-center items-center gap-5 font-semibold text-xs mt-14">
                  <div
                    className="text-white bg-[#017C57] rounded-full px-8 py-1 cursor-pointer"
                    onClick={() =>
                      handleHospitalApprove(selectedHospitalId, "ACTIVE")
                    }
                  >
                    Yes
                  </div>
                  <div
                    style={{ border: "1px solid #017C57" }}
                    className="text-[#017C57] px-8 py-1 rounded-full cursor-pointer"
                    onClick={() => setApproveModal(false)}
                  >
                    No
                  </div>
                </div>
              )}
              <div className="absolute right-12 top-8 cursor-pointer">
                <img
                  src={CrossIcon}
                  alt="close"
                  onClick={() => setApproveModal(false)}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Reject Modal */}
      {rejectModal && (
        <div className="fixed top-0 left-0 h-screen w-screen flex justify-center items-center bg-[#017c5780] z-30">
          <div className="relative h-[340px] w-[720px] flex justify-center items-center bg-white rounded-[16px]">
            <div className="w-full">
              <div className="text-2xl font-semibold text-[#191919] text-center">
                Are you sure you want to reject?
              </div>
              {submitting ? (
                <div className="flex justify-center mt-14">
                  <CircularProgress />
                </div>
              ) : (
                <div className="flex justify-center items-center gap-5 font-semibold text-xs mt-14">
                  <div
                    className="text-white bg-[#017C57] rounded-full px-8 py-1 cursor-pointer"
                    onClick={() =>
                      handleHospitalApprove(selectedHospitalId, "REJECTED")
                    }
                  >
                    Yes
                  </div>
                  <div
                    style={{ border: "1px solid #017C57" }}
                    className="text-[#017C57] px-8 py-1 rounded-full cursor-pointer"
                    onClick={() => setRejectModal(false)}
                  >
                    No
                  </div>
                </div>
              )}
              <div className="absolute right-12 top-8 cursor-pointer">
                <img
                  src={CrossIcon}
                  alt="close"
                  onClick={() => setRejectModal(false)}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApproveHospital;
